// Module
var code = "<template> <require from=\"./tab-nav.scss\"></require> <slot></slot> </template> ";
// Exports
module.exports = code;